<script lang="ts" setup>
import { computed } from 'vue';
import { format } from 'date-fns';
import type { DataTableCellProps, CellConfig } from '../../';
import { computeCellValue } from '../../utils/data-table-cell.utils';

const props = defineProps<DataTableCellProps<CellConfig>>();

defineEmits(['rowAction']);

const getValue = computed(() =>
  computeCellValue(props) ? format(new Date(computeCellValue(props)), props.cellConfig.dateFormat) : ''
);
</script>

<template>
  <slot>
    <span>{{ getValue }}</span>
  </slot>
</template>
